'use client';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { EmblaOptionsType } from 'embla-carousel';

import EmblaCarousel from '@/components/Carousel/EmblaCarousel';
import { ClientOnly } from '@/components/ClientOnlyMarquee';
import { SingleReview } from '@/components/Reviews/ReviewComponent';
import { Review } from '@/types';

const OPTIONS: EmblaOptionsType = { loop: true };

interface ReviewProps {
  reviews: Review[];
}

export function Reviews(props: ReviewProps) {
  const reviews = props.reviews ?? [];
  const firstReview = reviews[0];

  return (
    <Container sx={{ p: 0 }}>
      <ClientOnly
        fallback={
          firstReview ? (
            <Box sx={{ minHeight: 200 }}>
              <SingleReview key={firstReview.documentId} review={firstReview} />
            </Box>
          ) : null
        }
      >
        <EmblaCarousel options={OPTIONS}>
          {reviews.map((review) => (
            <SingleReview key={review.documentId} review={review} />
          ))}
        </EmblaCarousel>
      </ClientOnly>
    </Container>
  );
}
